// extracted by mini-css-extract-plugin
export var defaultContainer = "GlobalSearch-module--default-container--4043a";
export var emptySearchContainer = "GlobalSearch-module--empty-search-container--5bce6";
export var resultsStats = "GlobalSearch-module--results-stats--8a864";
export var searchSection = "GlobalSearch-module--search-section--aeacb";
export var searchSectionTitle = "GlobalSearch-module--search-section-title--f195f";
export var stickySearchContainer = "GlobalSearch-module--sticky-search-container--d6692";